import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import moment from 'moment';

import Footer from '../components/global/footer/index';
import HeaderSearch from '../components/global/header/headerSearch';
import Header from '../components/global/header';
import CityChange from '../homepage/components/CityChange';

import Doctor from './common/Doctor';

import { useDoctorPageApi, useDoctorScheduleApi } from './api';
import { usePatientsApi } from '../list/doctorsPageList/api';

import { useUrlParser } from '../../utils/useUrlParser';

import { isMobile } from '../../utils/mobile';


export default function DoctorPageComponent({
  doctor,
  doctorSchedule,
  getDoctor,
  getDoctorSchedule,
  doctorsByDaysSchedule,
  getDoctorsByDaysSchedule,
  getPatients,
  user,
  setCalendarDate,
  patients,
  doctorId,
  isModal,
  currentjobId,
  medicalServicesId = null,
  currentDate,
  jobDoctorScheduleDays,
  searchFilters,
}) {

  const urlParser = useUrlParser();
  const initialSelectedDate = currentDate || urlParser.urlData.params?.calendar_date || moment().format('YYYY-MM-DD');
  const [selectedDate, setSelectedDate] = useState(initialSelectedDate);
  const [selectedJobId, setSelectedJobId] = useState(null);

  medicalServicesId = (medicalServicesId || urlParser.urlData.params?.medical_service_id || null);

  currentjobId = (currentjobId || urlParser.urlData.params?.job_id || null);

  // If searchFilters not provided (not a modal), read from URL params
  const effectiveSearchFilters = searchFilters || {
    onlyAvailable: urlParser.urlData.params?.onlyAvailable === 'true',
    byReferral: urlParser.urlData.params?.byReferral === 'true',
    screening_40_plus: urlParser.urlData.params?.screening_40_plus === 'true',
    defencer_benefit: urlParser.urlData.params?.defencer_benefit === 'true',
  };
  
  useDoctorPageApi({ getDoctor, doctor, propDoctorId: doctorId, doctorSchedule, doctorsByDaysSchedule, medicalServicesId });
  const {
    currentDoctorSchedule,
    isSelectedDateLoading,
  } = useDoctorScheduleApi({
    doctor,
    getDoctorsByDaysSchedule,
    doctorSchedule,
    doctorsByDaysSchedule,
    propDoctorId: doctorId,
    medicalServicesId,
    searchFilters: effectiveSearchFilters,
    currentjobId,
    selectedDate,
    selectedJobId,
  });
  usePatientsApi({ getPatients, token: user.token, patients });
  
  const [isMobileView, setIsMobileView] = useState(isMobile());
    
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(isMobile());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  
  if (doctor?.loaded && !doctor?.data) return <Redirect to="/not-found-page" />;  

  // Render only the Doctor component if isModal is true
  if (isModal) {
    return (
      <Container>
        {doctor.loading ? null : Boolean(doctor.data?.id) && (
          <Doctor
            key={doctor.data.id}
            id={doctor.data.id}
            description={doctor.data.description}
            full_name={doctor.data.full_name}
            jobs={doctor.data.jobs}
            indicators={doctor.data.indicators}
            specializations={doctor.data.specializations}
            doctorSchedule={doctorSchedule}
                currentDoctorSchedule={currentDoctorSchedule}
            phones={doctor.data.contacts.filter((contact) => contact.type === 'phone')}
            rating={doctor.data.rating}
            photo={doctor.data.photo}
            doctor={doctor.data}
                byDaysSchedule={doctorsByDaysSchedule.data[0]}
            user={user}
            setCalendarDate={setCalendarDate}
            patients={patients?.data}
            isModal={isModal}
            currentjobId={currentjobId}
            medicalServicesId={medicalServicesId}
            currentDate={currentDate}
            jobDoctorScheduleDays={jobDoctorScheduleDays}
            searchFilters={effectiveSearchFilters}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
              onSelectedJobIdChange={setSelectedJobId}
              isSelectedDateLoading={isSelectedDateLoading}
          />
        )}
      </Container>
    );
  }

  // Regular full page view with header and footer
  return (
    <div>
      {!localStorage.getItem('cityId') && <CityChange disableRedirect />}
      {isMobileView ? (
        <Header />
      ) : (
        <HeaderSearch city={user?.city} breadCrumbs={{ className: 'doctor-page' }} />
      )}
      <main>
        <div className="medic-feature-wrapper">
          <Container>
            {Boolean(doctor.data?.id) && (
              <Doctor
                key={doctor.data.id}
                id={doctor.data.id}
                description={doctor.data.description}
                full_name={doctor.data.full_name}
                jobs={doctor.data.jobs}
                indicators={doctor.data.indicators}
                specializations={doctor.data.specializations}
                doctorSchedule={doctorSchedule}
                currentDoctorSchedule={currentDoctorSchedule}
                phones={doctor.data.contacts.filter((contact) => contact.type === 'phone')}
                rating={doctor.data.rating}
                photo={doctor.data.photo}
                doctor={doctor.data}
                byDaysSchedule={doctorsByDaysSchedule.data[0]}
                user={user}
                setCalendarDate={setCalendarDate}
                patients={patients?.data}
                searchFilters={effectiveSearchFilters}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                onSelectedJobIdChange={setSelectedJobId}
                isSelectedDateLoading={isSelectedDateLoading}
              />
            )}
          </Container>
        </div>
      </main>
      <Footer />
    </div>
  );
}
